import { render, staticRenderFns } from "./file-template-component.vue?vue&type=template&id=6a1b800a&scoped=true&"
import script from "./file-template-component.vue?vue&type=script&lang=js&"
export * from "./file-template-component.vue?vue&type=script&lang=js&"
import style0 from "./file-template-component.vue?vue&type=style&index=0&id=6a1b800a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b800a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1b800a')) {
      api.createRecord('6a1b800a', component.options)
    } else {
      api.reload('6a1b800a', component.options)
    }
    module.hot.accept("./file-template-component.vue?vue&type=template&id=6a1b800a&scoped=true&", function () {
      api.rerender('6a1b800a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file-template-component.vue"
export default component.exports